/**
 * GlobalConfig Queries - Extended with siteId lookup
 *
 * @override
 * - Re-exports all base global-config queries from @amblique/contentful
 * - Adds getGlobalConfigBySiteId queries (base, default, full variants)
 */

import gql from 'graphql-tag';

import {
  BaseGlobalConfigFragment,
  GlobalConfigFragment,
  FullGlobalConfigFragment,
} from '@amblique/king-living/app/contentful/fragments/global-config';

// Re-export all base queries
export * from '@amblique/contentful/app/contentful/queries/global-config.queries';

/**
 * Get a single GlobalConfig by siteId (base - scalars only)
 */
export const getBaseGlobalConfigBySiteId = gql`
  ${BaseGlobalConfigFragment}

  query GetBaseGlobalConfigBySiteId($siteId: String!, $locale: String!, $preview: Boolean) {
    globalConfigCollection(
      where: { siteId: $siteId }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...BaseGlobalConfigFragment
      }
    }
  }
`;

/**
 * Get a single GlobalConfig by siteId (standard - 1 level deep)
 */
export const getGlobalConfigBySiteId = gql`
  ${GlobalConfigFragment}

  query GetGlobalConfigBySiteId($siteId: String!, $locale: String!, $preview: Boolean) {
    globalConfigCollection(
      where: { siteId: $siteId }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...GlobalConfigFragment
      }
    }
  }
`;

/**
 * Get a single GlobalConfig by siteId (full - 2 levels deep)
 */
export const getFullGlobalConfigBySiteId = gql`
  ${FullGlobalConfigFragment}

  query GetFullGlobalConfigBySiteId($siteId: String!, $locale: String!, $preview: Boolean) {
    globalConfigCollection(
      where: { siteId: $siteId }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...FullGlobalConfigFragment
      }
    }
  }
`;
